export default __webpack_public_path__ + "static/media/New Logo.394c998c.png";